export {Vacancies} from './views/VacanciesPage';
export {Vacancy} from './views/VacancyPage';
